module.exports = __webpack_public_path__ + "img/balloon3.940cc041.png";